import memoize from 'lodash/memoize';
export const _memoize = memoize;
